import { useState, useEffect } from 'react';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import { useNavigateWithRedirect } from '@Hooks/useNavigateWithRedirect';
import { IoSettingsOutline, IoLogOutOutline } from 'react-icons/io5';
import { useReduxActiveUser } from '@Hooks/reduxActiveUserHook/useReduxActiveUser';
import BorderBlueButtonV2 from '@CommonRepresentationalDisplay/Buttons/BorderBlueButtonV2';
import ErrorHandler from '@Root/ErrorHandler';
import UserAuthService from '@Helpers/URLHelpers/UserAuthService';
import './OptionsDropDown.scss';

export default function OptionsDropDown(props) {

    const [anchorMenu, setAnchorMenu] = useState(null);
    const [showMenu, setShowMenu] = useState(false);
    new ErrorHandler();
    const navigate = useNavigateWithRedirect();
    const { activeUser } = useReduxActiveUser();
    const addClass = props.addClass === null || props.addClass === undefined ? '' : props.addClass;
    const colorList = ['#2784B9', '#40c47d', '#FDB16C', '#b06060', '#f77474', '#6080b0', '#9a60b0', '#6cb060',
        '#b0ae60', '#65412b', '#cc9963', '#e1bd83', '#60748b', '#744700', '#c8d579', '#5f8fba', '#3e6073', '#8e6dc1', '#473785',
       '#9158a9',  '#7f3f7a', '#583e84', '#073763', '#20124d', '#3d124d', '#64113f', '#780448', '#003e23', '#108764', '#1a4c3d',
        '#c8d77f', '#11888b', '#1a95bd', '#0d6c7b', '#25b56e', '#006e3d'];
    const className = 'optionsDropDown';

    useEffect(() => {
    }, [])

    const logOut = () => {
        const userAuthService = new UserAuthService();
        userAuthService.logout();
    };

    const handleOptionsPopup = (event) => {
        if(!showMenu){
            if(!!event) {
                setAnchorMenu(event.currentTarget);
                setShowMenu(true);
            }
        } else {
            setAnchorMenu(null);
            setShowMenu(false);
        }
    }

    const handleLoginClick = () => {
        navigate('/login');
    };

    const handleSettingsClick = () => {
        setAnchorMenu(null);
        setShowMenu(false);
        navigate('/userManagement/settings?tab=0');
    };

    const getInitials = (string) => {
        if(!!string && string.length > 0) {
            string = string.trim();
            var names = string?.split(' '),
                initials = names[0]?.substring(0, 1)?.toUpperCase();
            if (names?.length > 1) {
                initials += names[names?.length - 1]?.substring(0, 1)?.toUpperCase();
            } else {
                names = string?.split('@');
                initials = names[0]?.substring(0, 1)?.toUpperCase();

                if (names?.length > 1) {
                    initials += names[names?.length - 1]?.substring(0, 1)?.toUpperCase();
                }
            }
            return initials;
        }
        return 'N/A';
    };

    const renderUserAvatar = (size) => {
        return (
            !!activeUser.photo && activeUser.photo !== '' ?
                <Avatar
                    src={activeUser?.photo}
                    sx={{
                        width: size,
                        height: size,
                        border: '2px solid #fff',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                    }}
                />
            :
                <Avatar
                    sx={{
                        bgcolor: colorList[activeUser?.fullName?.charCodeAt(0) % colorList?.length] + ' !important',
                        width: size,
                        height: size,
                        border: '2px solid #fff',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                        fontWeight: 600
                    }}>
                    {activeUser?.fullName ? getInitials(activeUser?.fullName) : 'UA'}
                </Avatar>
        )
    }

    return (
        <div className={className}>
                {
                    Object.keys(activeUser || {}).length !== 0 ?
                        <div className={className + '__header__profile__group'} onClick={handleOptionsPopup}>
                            <div className="header-profile-pic">
                                {renderUserAvatar(37)}
                            </div>
                        </div>
                    :
                        <div className={className + '__right__b3'}>
                            <BorderBlueButtonV2
                                text={'Login'}
                                onClick={handleLoginClick}/>
                        </div>
                }
            <div className={className + '__dropdown' + addClass}>
                {
                    showMenu &&
                    <Menu
                        open={showMenu}
                        onClose={handleOptionsPopup}
                        anchorEl={anchorMenu}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        PaperProps={{
                            elevation: 8,
                            sx: {
                                overflow: 'visible',
                                filter: 'drop-shadow(0px 4px 20px rgba(0,0,0,0.12))',
                                mt: 1.5,
                                borderRadius: '16px',
                                minWidth: '280px',
                                maxWidth: '320px',
                            },
                        }}>
                        <div className={className + '__dropContent'}>
                            {/* User Profile Section */}
                            <div className={className + '__dropContent__profile'}>
                                <div className={className + '__dropContent__profile__avatar'}>
                                    {renderUserAvatar(52)}
                                </div>
                                <div className={className + '__dropContent__profile__info'}>
                                    <div className={className + '__dropContent__profile__name'}>
                                        {activeUser?.fullName}
                                    </div>
                                    <div className={className + '__dropContent__profile__username'}>
                                        @{activeUser?.userName}
                                    </div>
                                </div>
                            </div>

                            <Divider sx={{ my: 1 }} />
                        </div>
                        <div className={className + '__dropContent'}>
                            <MenuItem
                                className={className + '__dropContent__action'}
                                onClick={handleSettingsClick}
                            >
                                <IoSettingsOutline className={className + '__dropContent__action__icon'} />
                                <span>Settings</span>
                            </MenuItem>
                            <Divider sx={{ my: 0.5 }} />

                            <MenuItem
                                className={className + '__dropContent__action ' + className + '__dropContent__action--logout'}
                                onClick={logOut}
                            >
                                <IoLogOutOutline className={className + '__dropContent__action__icon'} />
                                <span>Logout</span>
                            </MenuItem>
                        </div>
                    </Menu>
                }
            </div>
        </div>
    );
}
